import { AsYouType } from 'libphonenumber-js';

export default value => {
  const formatter = new AsYouType({
    defaultCountry: 'GB',
  });
  formatter.input(value);
  return formatter.isValid();
};
